import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Dialog from "@material-ui/core/Dialog";
import makeStyles from "@material-ui/core/styles/makeStyles";
import React, { useState } from "react";
import MockTooltipComponent from "./MockTooltipComponent";
import portIcon from "../../assets/images/port.svg";

const MockGlobalRiskLocationModal = ({ onCallBack }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(true);

  return (
    <div>
      <Dialog
        aria-labelledby="simple-dialog-title"
        open={open}
        classes={{
          paper: classes.dialog,
        }}
      >
        <MockTooltipComponent
          placement="left-start"
          open={open}
          popper={classes.locationTooltip}
          tooltipArrowStyle={classes.locationArrowStyle}
          title={
            <>
              <Typography className={classes.tooltipTitleStyle}>
                See updates from ports
              </Typography>
              <p className={classes.tooltipTextStyle}>
                Kavida monitors dwell time at all of the ports your suppliers use.
              </p>
              <div
                style={{
                  width: "64px",
                  padding: "8px",
                  backgroundColor: "#ffffff",
                  color: "#000000",
                  fontWeight: 600,
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setOpen(false);
                  onCallBack();
                }}
              >
                <span>Continue</span>
              </div>
              <Typography className={classes.stepTextStyle}>
                (19/19)
              </Typography>
            </>
          }
          child={
            <div className={classes.modalRoot}>
              <div style={{ display: "flex" }}>
                <img src={portIcon} className={classes.portIcon} />
                <Typography className={classes.composeEmailStyle}>
                  Port of Colombo
                </Typography>
              </div>
              <Grid container>
                <Grid item xs={6}>
                  <Grid item xs={12}>
                    <p
                      className={classes.optionLabelStyle}
                      style={{ marginBottom: 0 }}
                    >
                      Export Dwell
                    </p>
                  </Grid>
                  <Grid item xs={12}>
                    <p
                      className={classes.optionValueStyle}
                      style={{ margin: 0 }}
                    >
                      3 days 9 hours
                    </p>
                  </Grid>
                </Grid>
                <Grid item xs={6}>
                  <Grid item xs={12}>
                    <p
                      className={classes.optionLabelStyle}
                      style={{ marginBottom: 0 }}
                    >
                      Import Dwell
                    </p>
                  </Grid>
                  <Grid item xs={12}>
                    <p
                      className={classes.optionValueStyle}
                      style={{ margin: 0 }}
                    >
                      3 days 5 hours
                    </p>
                  </Grid>
                </Grid>
              </Grid>
            </div>
          }
        />
      </Dialog>
    </div>
  );
};

export default MockGlobalRiskLocationModal;

const useStyles = makeStyles((theme) => ({
  modalRoot: {
    width: "261px",
    height: "108px",
    padding: "16px 16px",
  },
  composeEmailStyle: {
    fontSize: "20px",
    fontFamily: "Inter",
    fontWeight: "700",
    lineHeight: "24px",
  },
  optionLabelStyle: {
    fontSize: "14px",
    fontWeight: "700",
    fontFamily: "Inter",
  },
  backDrop: {
    backdropFilter: "blur(8px)",
    backgroundColor: "rgba(255,255,255,0.01)",
  },
  dialog: {
    position: "absolute",
    left: "60%",
    top: "60%",
    overflow: 'hidden'
  },
  optionValueStyle: {
    fontSize: "12px",
    fontWeight: "400",
    fontFamily: "Inter",
  },
  tooltipTextStyle: {
    marginTop: "0px",
    fontSize: "14px",
    fontFamily: "Inter",
    lineHeight: "20px",
  },
  tooltipTitleStyle: {
    marginTop: "0px",
    fontSize: "20px",
    fontFamily: "Inter",
    fontWeight: "700",
    marginBottom: '16px'
  },
  locationTooltip: {
    width: "375px",
    height: "148px",
    marginRight: "-70px",
    marginTop: "-48px",
  },
  locationArrowStyle: {
    marginTop: "-120px !important",
    top: '200px !important',
    color: '#373D3F'
  },
  portIcon: {
    paddingRight: "10px"
  },
  stepTextStyle: {
    padding: "0px",
    margin: "0px",
    fontSize: "14px",
    textAlign: "end",
    marginTop: "-10px",
    marginBottom: "-10px",
  }
}));
